import axios from "axios";

const DEFAULT_TIMEOUT =  300000;
export const setaxiosheader = (headers) => {
  axios.defaults.headers.common = {...axios.defaults.headers.common, Authorization: headers};
  axios.defaults.timeout = DEFAULT_TIMEOUT;
};

